import { useState, useEffect } from 'react';
import { getUserStats, getDocumentStats, type AdminStats } from '@/shared/db';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

export function useAdminStats() {
  const { t } = useTranslation();
  const [stats, setStats] = useState<AdminStats | null>(null);
  const [documentStats, setDocumentStats] = useState<{
    total: number;
    byCountry: Record<string, number>;
    byType: Record<string, number>;
    byStatus: Record<string, number>;
  } | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = async () => {
    setLoading(true);
    setError(null);

    try {
      const [userStatsData, docStatsData] = await Promise.all([
        getUserStats(),
        getDocumentStats(),
      ]);

      setStats(userStatsData);
      setDocumentStats(docStatsData);
    } catch (err: unknown) {
      console.error('Error fetching admin stats:', err);
      const errorMessage =
        err instanceof Error ? err.message : t('admin.errors.fetchStatsFailed');
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    stats,
    documentStats,
    loading,
    error,
    refetch: fetchStats,
  };
}

